import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import { getUserProfileAction } from "../auth/authServices";
import * as requestFromServer from "./userPermissionApis";

export const updateOrgPermissionAction =
  (dataToBeSent, setLoading, setUserSession) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateOrgPermissions(dataToBeSent);
    if (response) {
      toastService.success("Successfully updated permissions");
      dispatch(getUserProfileAction(setUserSession));
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

export const updateSuperAdminPermissionAction =
  (dataToBeSent, setLoading, setUserSession) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateSuperAdminPermissions(
      dataToBeSent
    );
    if (response) {
      dispatch(getUserProfileAction(setUserSession));
      toastService.success("Successfully updated permissions");

      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
